import type { ButtonConfig } from '../../declare'
import { Button } from 'antd'
import { EasyModal, EasyIcon } from 'src/components'
import { PrintTemplate, PrintStandard } from 'src/components/root/components/common'

type Props = {
  config: ButtonConfig
}

const PrintBtn = (props: Props) => {
  const { __READONLY__, LABEL, ICON, WORD_TEMPLATE_CODE } = props.config

  if (!WORD_TEMPLATE_CODE) {
    return (
      <EasyModal
        fullModal
        modal={{
          title: '打印预览',
          styles: { body: { overflow: 'hidden auto' } },
        }}
        disabled={__READONLY__}
        slot={<Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='PrinterOutlined' />}>{LABEL}</Button>}
      >
        <PrintStandard />
      </EasyModal>
    )
  }

  return (
    <EasyModal
      fullModal
      modal={{
        title: '模板预览',
        styles: { body: { overflow: 'hidden' } }
      }}
      disabled={__READONLY__}
      slot={<Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='PrinterOutlined' />}>{LABEL}</Button>}
    >
      <PrintTemplate code={WORD_TEMPLATE_CODE} />
    </EasyModal>
  )
}

export default PrintBtn